import { CONTRACTOR_TYPES } from "../../../../domain/ContractorType";
import { Card } from "react-bootstrap";
import { BadgeDomain } from "../../../../_components/Abstractions/BadgeDomain";
import { Link } from "react-router-dom";

export function IntermediaryManagedContractorsDetails({ contractorTypes, managedContractors }) {
  if (!contractorTypes?.includes(CONTRACTOR_TYPES.INTERMEDIARY)) {
    return;
  }

  return (
    <>
      <Card>
        <Card.Header as="h4">Klienci pośrednika</Card.Header>
        <Card.Body className="upper">
          {(managedContractors == null || managedContractors?.length === 0) && (
            <>Brak klientów pośrednika</>
          )}
          {managedContractors?.map((contractor) => (
            <BadgeDomain
              key={contractor.contractorId}
              bg="info"
              size="small">
              <Link className="clear-link" to={`/contractors/${contractor.contractorId}`}>{contractor.name}</Link>
            </BadgeDomain>
          ))}
        </Card.Body>
      </Card>
    </>
  );
}